import axios from "axios";
import { toast } from "react-toastify";

export const base_url = process.env.REACT_APP_API_URL || "https://jdstore-api.onrender.com/api/";
export const fallback_url = "https://api.jdstore.in/api/";

// Request throttling
const requestQueue = [];
let isProcessing = false;
const THROTTLE_DELAY = 100; // 100ms between requests

const processQueue = async () => {
  if (isProcessing || requestQueue.length === 0) return;

  isProcessing = true;
  const { resolve, reject, requestFn } = requestQueue.shift();

  try {
    const result = await requestFn();
    resolve(result);
  } catch (error) {
    reject(error);
  }

  setTimeout(() => {
    isProcessing = false;
    processQueue();
  }, THROTTLE_DELAY);
};

export const throttledRequest = (requestFn) => {
  return new Promise((resolve, reject) => {
    requestQueue.push({ resolve, reject, requestFn });
    processQueue();
  });
};

const getTokenFromLocalStorage = () => {
  try {
    const customer = localStorage.getItem("customer");
    return customer ? JSON.parse(customer) : null;
  } catch (error) {
    console.error("Error parsing customer data:", error);
    localStorage.removeItem("customer");
    return null;
  }
};

// Handle logout
const handleLogout = () => {
  localStorage.removeItem("customer");
  localStorage.removeItem("token");
  window.location.href = "/login";
};

// Add axios interceptors for better error handling
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const errorCode = error.response?.data?.code;
      // Only force logout if user was previously logged in
      const isLoggedIn = !!localStorage.getItem("customer");
      if (isLoggedIn) {
        if (errorCode === 'TOKEN_EXPIRED') {
          toast.error("Your session has expired. Please login again.");
          setTimeout(handleLogout, 1500);
        } else if (errorCode === 'AUTH_FAILED' || errorCode === 'USER_NOT_FOUND') {
          toast.error("Please login again.");
          setTimeout(handleLogout, 1500);
        }
        // NO_TOKEN — user just not logged in, don't force logout
      }
    } else if (error.response?.status === 429) {
      console.warn('Rate limit exceeded, request will be retried');
    }
    return Promise.reject(error);
  }
);

export const config = {
  get headers() {
    return {
      Authorization: `Bearer ${getTokenFromLocalStorage()?.token || ""
        }`,
      Accept: "application/json",
    };
  },
};
